import { createApp } from "vue";
import mitt from "mitt";
import "lib-flexible/flexible";
import vconsole from "vconsole";

import "@/utils/h5Record.js";

const { origin } = window.location;
if (origin.includes("beta-ssweb.knowbox.cn") || origin.includes("192.168.")) {
  new vconsole();
}
/**
 * https://vant-contrib.gitee.io/vant/#/zh-CN/quickstart
 * Vant 中有个别组件是以函数的形式提供的，包括 Toast，Dialog，Notify 和 ImagePreview 组件。
 * 在使用函数组件时，unplugin-vue-components 无法自动引入对应的样式，因此需要手动引入样式。
 */
import "vant/es/toast/style"; // Toast
import "vant/es/dialog/style"; // Dialog
import "vant/es/notify/style"; // Notify
import "vant/es/image-preview/style"; // ImagePreview

import App from "./App.vue";
import store from "./store";
import router from "./router";

import "./style/normalize.css";
import "./style/reset.css";
import "./style/common.less";

// 导入并初始化Sentry
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/vue";
const app = createApp(App);
const emitter = mitt();
Sentry.init({
  app,
  dsn: "https://d60a33fb36f642f1905d3aaa7f83fe00@sentry.knowbox.cn/6",
  integrations: [
    new Integrations.BrowserTracing({
      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.01,
  ignoreErrors: [
    "handleJSByNative is not defined",
    "Cannot read properties of null (reading 'getItem')",
    "j.map is not a function. (In 'j.map(fe=>K(fe,ie,ee))', 'j.map' is undefined)",
    "onVisible is not defined",
    "The object is in an invalid state",
    "wx is not defined",
  ],
});
// 通过 app.provide(key, value) 全局注入一个属性 name
app.provide("emitter", emitter);

app.use(store).use(router).mount("#app");
